import React, {FC} from 'react';

import {cn} from '@bem-react/classname';
import {HelpPopover} from '@gravity-ui/components';
import MarkdownText from 'ui/components/MarkdownText';
import i18n from 'ui/i18n';

import VisuallyHidden from '../VisuallyHidden';

import {QuestionLabelProps} from './QuestionLabel.types';

import './QuestionLabel.scss';

const cnQuestionLabel = cn('QuestionLabel');

const QuestionLable: FC<QuestionLabelProps> = ({
    text,
    required,
    className,
    hint,
    header = false,
    id,
    error,
}) => (
    <h3 className={cnQuestionLabel('', [className])} id={id}>
        {Boolean(error) && <VisuallyHidden>{i18n('survey-page', 'sr-error-label')}</VisuallyHidden>}
        {required && (
            <span className={cnQuestionLabel('Required')} aria-hidden="true">
                *
            </span>
        )}
        {
            <MarkdownText
                text={text}
                as={'span'}
                variant={header ? 'header-1' : 'body-2'}
                color="primary"
                className={cnQuestionLabel('Text')}
            />
        }
        {required && <VisuallyHidden>{i18n('survey-page', 'required-sr-only')}</VisuallyHidden>}
        {hint && (
            <HelpPopover content={hint} hasArrow={false} className={cnQuestionLabel('Hint')} />
        )}
    </h3>
);
export default QuestionLable;
